import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-forest text-white/80 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 flex flex-col md:flex-row justify-between gap-8">
        <div>
          <div className="font-serif text-2xl text-white">Learn with Devid</div>
          <p className="mt-2 text-sm">{t.footer.tagline}</p>
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <Link to="/" className="hover:text-white transition-colors">{t.nav.home}</Link>
          <Link to="/reviews" className="hover:text-white transition-colors">{t.nav.reviews}</Link>
          <a href="mailto:brickademy66@gmail.com" className="hover:text-white transition-colors">brickademy66@gmail.com</a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 text-xs text-white/50">
          © {new Date().getFullYear()} Learn with Devid. {t.footer.rights}
        </div>
      </div>
    </footer>
  );
}
